import dynamic from 'next/dynamic'

const DynamicControls = dynamic(
    () => import('@components/display/photos/Lightbox').then(mod => mod.Controls),
    { ssr: false }
)

const Controls = (props) => <DynamicControls {...props} />

export default Controls